import { useNavigate } from 'react-router-dom'

import { Routes } from 'constants/routes'
import { setAxiosAuthorizationToken } from 'modules/axios'
import storage from 'modules/storage'
import { useAppDispatch } from 'store'
import { logout as logoutAction } from 'store/profile/actions'

export const useLogout = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const logout = () => {
    storage.clearToken()
    setAxiosAuthorizationToken(null)
    navigate(Routes.Main)
    dispatch(logoutAction())
  }

  return { logout }
}
